import { useEffect, useState } from "react";

function getDeviceState() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: true,
      width: 1024,
      height: 768,
    };
  }

  const width = window.innerWidth;
  const height = window.innerHeight;
  const userAgent = navigator.userAgent || "";
  const isTouchDevice =
    "ontouchstart" in window || Number(navigator.maxTouchPoints || 0) > 0;

  const mobileByAgent =
    /Android|iPhone|iPod|IEMobile|Opera Mini|Mobile/i.test(userAgent);

  const tabletByAgent =
    /iPad|Tablet|PlayBook|Silk/i.test(userAgent) ||
    (/Android/i.test(userAgent) && !/Mobile/i.test(userAgent)) ||
    (/Macintosh/i.test(userAgent) && isTouchDevice);

  const isMobile = width < 768 || mobileByAgent;
  const isTablet = !isMobile && (width < 1024 || tabletByAgent);

  return {
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    width,
    height,
  };
}

export function useDeviceDetection() {
  const [device, setDevice] = useState(function () {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: true,
      width: 1024,
      height: 768,
    };
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let timer = null;

    const updateDevice = () => {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        setDevice(getDeviceState());
        setIsLoading(false);
      }, 50);
    };

    setDevice(getDeviceState());
    setIsLoading(false);

    window.addEventListener("resize", updateDevice);
    window.addEventListener("orientationchange", updateDevice);

    return () => {
      if (timer) {
        clearTimeout(timer);
      }

      window.removeEventListener("resize", updateDevice);
      window.removeEventListener("orientationchange", updateDevice);
    };
  }, []);

  return {
    ...device,
    isLoading,
  };
}

export default useDeviceDetection;
